import React from 'react'
import { Redirect } from 'react-router-dom'

class ErrorBoundary extends React.Component {
    state = { hasError: false }

    componentDidCatch(error, info) {
        if (process.env.NODE_ENV !== 'development') {
            this.setState({ hasError: true })
        }
    }

    render() {
        if (this.state.hasError) {
            this.setState({ hasError: false })
            return <Redirect push to={'/internal-error'} />
        }

        return this.props.children
    }
}

export default ErrorBoundary
